import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DATA_CONFIG } from '../../injection-tokens';

/**
 * Direct contact details — Russ's phone and email shown as visible,
 * selectable text backed by `tel:` / `mailto:` links. Used where a page
 * wants the contact info inline (e.g. `/about/performance`,
 * `/x-ploration-jazz`) rather than only inside the bottom CTA buttons.
 * Values come from `DATA_CONFIG` so they share the site-wide single
 * source of truth (same source as the header, footer, and CTAs).
 */
@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent {
  private readonly dataConfig = inject(DATA_CONFIG);
  protected readonly phone = this.dataConfig.phone;
  protected readonly email = this.dataConfig.email;
  protected readonly phoneHref = this.dataConfig.phoneHref;
  protected readonly emailHref = this.dataConfig.emailHref;
}
